import Button from '../../Button/Button';
import { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

type MonthSelectorHeaderProps = {
    year: number;
    onYearChange: (year: number) => void;
};

export default function MonthSelectorHeader({
    year,
    onYearChange,
}: MonthSelectorHeaderProps) {
    const [internalYear, setYear] = useState<number>(year);
    const handleOnYearChange = (year: number) => {
        setYear(year);
        onYearChange(year);
    };

    return (
        <div className="alli-flex alli-items-center alli-text-gray-900">
            <Button
                onClick={() => handleOnYearChange(internalYear - 1)}
                variant="text-secondary"
                type="button"
                className="alli-text-primary alli--m-1.5 alli-flex alli-flex-none alli-items-center alli-justify-center alli-p-1.5 hover:alli-text-gray-500">
                <span className="alli-sr-only">Previous Year</span>
                <ChevronLeftIcon className="alli-size-5" aria-hidden="true" />
            </Button>
            <div className="alli-flex-auto alli-text-center alli-text-sm alli-font-semibold">
                {internalYear}
            </div>
            <Button
                onClick={() => handleOnYearChange(internalYear + 1)}
                variant="text-secondary"
                type="button"
                className="alli-text-primary alli--m-1.5 alli-flex alli-flex-none alli-items-center alli-justify-center alli-p-1.5 hover:alli-text-gray-500">
                <span className="alli-sr-only">Next Year</span>
                <ChevronRightIcon className="alli-size-5" aria-hidden="true" />
            </Button>
        </div>
    );
}
